import { Spinner } from '@components/ui/Spinner';
import { TimeLine } from '@components/ui/TimeLine';
import { TimeLineTrackLine } from '@components/ui/TimeLine/TimeLineTrackLine';
import { NO_INFORMATION_LABEL } from '@utils/text/commonText';

import { DocumentTimeLineItem } from './DocumentTimeLineItem';
import { type DocumentTimeLineProps } from './types';

const DocumentTimeLine = ({
  documentMovements,
  isLoading = false,
}: DocumentTimeLineProps) => {
  if (isLoading)
    return (
      <div className="m-auto">
        <Spinner />
      </div>
    );

  if (documentMovements === undefined || documentMovements.length === 0)
    return <p>{NO_INFORMATION_LABEL}</p>;

  return (
    <TimeLine>
      <TimeLineTrackLine />
      {documentMovements.map(movement => (
        <DocumentTimeLineItem
          key={movement.id}
          action={movement.action}
          date={movement.updatedAt}
          reason={movement.reason}
          status={movement.statusDescription}
        />
      ))}
    </TimeLine>
  );
};

export { DocumentTimeLine };
